<template>
  <div>
    <b-row class="card mt-5">
      <div class="w-100">
        <h5 class="title-card">
          <i class="fas fa-pen"></i> Filtros
        </h5>
      </div>

      <div class="w-100 p-3">
        <b-row>
          <b-col lg="4">
            <b-form-group label="Nome do agente">
              <b-form-input v-model="filters.name"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col lg="4">
            <b-form-group label="Email">
              <b-form-input v-model="filters.email"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col lg="4">
            <b-form-group label="CPF">
              <b-form-input v-model="filters.cpf"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col lg="3">
            <b-form-group label="Estado">
              <b-form-select @change="getCities" v-model="filters.province" :options="provinces"></b-form-select>
            </b-form-group>
          </b-col>

          <b-col lg="3">
            <b-form-group label="Cidade">
              <b-form-select :disabled="!cities.length" v-model="filters.city" :options="cities"></b-form-select>
            </b-form-group>
          </b-col>

          <b-col lg="6" class="align-btn">
            <b-button variant="info" @click="getList(true)" class="mr-2">Pesquisar</b-button>
            <b-button variant="danger" @click="clearFilters">Limpar</b-button>
          </b-col>
        </b-row>
      </div>
    </b-row>

    <b-row class="card mt-5">
      <div class="w-100">
        <h5 class="title-card">
          <i class="fas fa-users"></i> Agentes Cadastrados
        </h5>
      </div>

      <div class="w-100 p-3">
        <b-button variant="primary" :to="{ name: 'agents-create' }">
          <i class="fas fa-plus"></i> Adicionar novo agente
        </b-button>
      </div>

      <div class="w-100 p-3">
        <b-table
        bordered
        responsive
        :busy="load"
        :items="agents"
        :fields="columns">
        <template #table-busy>
          <div class="text-center text-success my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>
        <template v-slot:cell(actions)="data">
          <b-button
          v-b-tooltip.hover
          title="Editar cliente"
          :to="{ name: 'agents-edit', params: { id: data.item.id } }"
          size="sm"
          class="mr-1"
          variant="warning">
            <i class="fas fa-pen"></i>
          </b-button>
        </template>
        </b-table>
      </div>
    </b-row>
  </div>
</template>
<script>
import AgentService from '@/Services/AgentService';
import HelperService from '@/Services/HelperService';

export default {
  data() {
    return {
      columns: AgentService.getFieldsTableAgents(),
      load: true,
      agents: [],
      provinces: {},
      cities: {},
      filters: {
        name: '',
        email: '',
        cpf: '',
        province: '',
        city: '',
      },
    };
  },
  methods: {
    async getList(hasFilter) {
      const filters = { ...this.filters };

      try {
        const { data } = hasFilter ? await AgentService.getList(filters) : await AgentService.getList();
        this.agents = data.map((item) => ({
          id: item.id,
          name: item.name,
          email: item.email,
          contact: item.phone_mobile,
          city: item.address ? item.address.city.name : '',
          province: item.address ? item.address.city.province.initial : '',
        }));
      } catch (error) {
        console.log(error);
      }

      this.load = false;
    },

    clearFilters() {
      this.getList(false);
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = '';
      });
    },

    async getProvinces() {
      try {
        const { data } = await HelperService.getProvinces();
        this.provinces = data.map((item) => ({
          value: item.id,
          text: item.name,
        }));
      } catch (error) {
        console.log(error);
      }
    },

    async getCities() {
      const params = {
        province_id: this.filters.province,
      };

      try {
        const { data } = await HelperService.getCities(params);
        this.cities = data.map((item) => ({
          value: item.id,
          text: item.name,
        }));
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    this.getList();
    this.getProvinces();
  },
};
</script>
